import React, { useState, memo, useImperativeHandle, forwardRef } from 'react';
import { Row, Col } from 'antd';
import { NewRadio } from './radio';

const MultiRadio = (props, ref) => {
  const { values = {}, options = [] } = props;

  let initialAnswer;
  if (values.choiceCollection) {
    initialAnswer = values.choiceCollection.map((v) =>
      v === null ? null : String(parseInt(v, 10) - 1),
    );
  }

  const [answer, setAnswer] = useState(
    initialAnswer || Array.from(Array(options.length).map((_) => null)),
  );
  const sectionCount = options.length || 1;
  const getText = (i, op) => op[i]?.text || null;

  useImperativeHandle(ref, () => ({
    getValues: () => ({
      choiceCollection: answer.map((c) =>
        c == null ? null : String(parseInt(c, 10) + 1),
      ),
    }),
  }));

  if (!Array.isArray(options)) {
    return <div />;
  }

  const onEachSectionChange = (index) => (_, v) => {
    const sectionOption = options[index]?.options || [];
    const newAnswer = [...answer];
    newAnswer[index] = sectionOption.findIndex((e) => e.text === v);
    setAnswer(newAnswer);
  };

  const radios = options.map((o, i) => (
    <Col span={Math.floor(24 / sectionCount)} key={i}>
      <span className="radio-section-name">{o.section}</span>
      <NewRadio
        options={o.options}
        value={getText(answer[i], o.options)}
        onChange={onEachSectionChange(i)}
      />
    </Col>
  ));

  return (
    <Row style={{ width: '100%' }} className="multi-radio">
      {radios}
    </Row>
  );
};

export default memo(forwardRef(MultiRadio));
